import { Box } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useOperationsStore } from '@tom-ui/operations'
import { ConfirmationDialog, Loader, useMinimalsTheme } from '@tom-ui/ui'
import { OccupancyType, useYardStores, YardPositionSelector } from '@tom-ui/yard'
import { observer } from 'mobx-react-lite'
import { ContainerYardOperationViewStore } from './ContainerYardOperationViewStore'

interface Props {
  store: ContainerYardOperationViewStore
}
export const ContainerYardOperationDialog = observer(({ store }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const { appStore } = useOperationsStore()
  const { yardPositionSelectorStore } = useYardStores()

  const handleConfirm = async () => {
    try {
      store.setLoading(true)
      if (!store.journeyId) throw new Error('Container journey id is missing')

      await store.beforeYardPositionChangeConfirmation?.()
      await yardPositionSelectorStore.stackInJourney(store.journeyId, store.containerNumber)

      store.setHasSelectedDestination(false)
      appStore.setShowAlert(
        'success',
        t('positionWasUpdatedSuccessfully', 'Position was updated successfully'),
      )
      store.close()
    } catch {
      appStore.setShowAlert('error', t('failedToUpdatePosition', 'Failed to update position'))
    } finally {
      store.setLoading(false)
    }
  }

  if (!store.journeyId) {
    return
  }

  return (
    <>
      <Loader show={store.isLoading} />
      <ConfirmationDialog
        open={store.isOpen}
        title={store.title ?? t('correctYardLocation', 'Correct yard location')}
        primaryActionText={t('confirm', 'Confirm')}
        primaryActionDisabled={!store.hasSelectedDestination}
        primaryActionDataCy={'submit-update-container-location'}
        onConfirm={handleConfirm}
        closeLabel={t('cancel', 'Cancel')}
        onClose={() => store.close()}
        maxWidth='lg'
        hasBorderTop
      >
        {store.message && <Box mb={theme.customSpacing.s}>{store.message}</Box>}
        <YardPositionSelector
          journeyId={store.journeyId}
          prefillPosition={OccupancyType.Occupied}
          onChange={position => store.setHasSelectedDestination(!!position)}
        />
      </ConfirmationDialog>
    </>
  )
})
